"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var F_Instant_Elapsed_1 = require("./F_Instant_Elapsed");
var F_Instant_Is_1 = __importDefault(require("./F_Instant_Is"));
var F_Instant_Add_1 = __importDefault(require("./F_Instant_Add"));
var java_js_dateformat_1 = require("java-js-dateformat");
var F_Instant = /** @class */ (function () {
    /** @hidden */
    function F_Instant(instant) {
        this.instant = instant;
        this.elapsed = new F_Instant_Elapsed_1.F_Instant_Elapsed(this.instant);
        this.is = new F_Instant_Is_1.default(this.instant);
        this.add = new F_Instant_Add_1.default(this.instant);
        this.subtract = new F_Instant_Add_1.default(this.instant, -1);
        this.toIso = this.toIso.bind(this);
        this.format = this.format.bind(this);
    }
    F_Instant.prototype.format = function (format, locale, timeZone) {
        return java_js_dateformat_1.Formatters.formatInstant('' + this.instant.epochMilliseconds, format, locale, timeZone);
    };
    F_Instant.prototype.toIso = function () {
        return this.instant.toString();
    };
    return F_Instant;
}());
exports.default = F_Instant;
//# sourceMappingURL=F_Instant.js.map